import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useCardStyles } from './cardStyles';

export const TextCard = (props) => {
  const classes = useCardStyles();

  return (
    <>
      <Card className={classes.card}>
        <CardContent>
          <Typography gutterBottom variant="h5" component="h2">
            {props.Title}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            {props.Text}
          </Typography>
        </CardContent>
      </Card>
    </>
  )
}

export default TextCard;
